import PaymentMethod from './PaymentMethod';
export default PaymentMethod;
